import React from "react";
import SyncLoader from "react-spinners/SyncLoader";

function Loader(){
  return (
    <div style={{height:'100%',width:'100%',display:'flex',justifyContent:'center',alignItems:'center'}}>
      <SyncLoader color={"#064780"} speedMultiplier={1}  size={10}/>
    </div>
  );
}
export default Loader;